var map = {
	"./flags/en.svg": 1026,
	"./flags/es.svg": 1027,
	"./flags/fr.svg": 1028,
	"./flags/it.svg": 1029,
	"./flags/nl.svg": 1030,
	"./flags/pt.svg": 1031,
	"./icons/icon-arrow-up.svg": 1032,
	"./icons/icon-beach--green.svg": 1033,
	"./icons/icon-beach--red.svg": 1034,
	"./icons/icon-beach.svg": 1035,
	"./icons/icon-bell.svg": 1036,
	"./icons/icon-break.svg": 1037,
	"./icons/icon-caret-down-bold.svg": 1038,
	"./icons/icon-caret-down.svg": 1039,
	"./icons/icon-caret-left--white.svg": 1040,
	"./icons/icon-caret-right-bold.svg": 1041,
	"./icons/icon-chevron-circle-left--white.svg": 1042,
	"./icons/icon-chevron-circle-left.svg": 1043,
	"./icons/icon-chevron-circle-right--white.svg": 1044,
	"./icons/icon-chevron-circle-right.svg": 1045,
	"./icons/icon-chevron-down.svg": 158,
	"./icons/icon-chevron-up.svg": 159,
	"./icons/icon-close.svg": 1046,
	"./icons/icon-dropdown.svg": 1047,
	"./icons/icon-email.svg": 1048,
	"./icons/icon-heart-fill.svg": 1049,
	"./icons/icon-heart-outline.svg": 1050,
	"./icons/icon-heart-red.svg": 1051,
	"./icons/icon-info--circle.svg": 1052,
	"./icons/icon-legend-buoys.svg": 1053,
	"./icons/icon-legend-star.svg": 1054,
	"./icons/icon-legend-swell-arrow.svg": 1055,
	"./icons/icon-legend-swell.svg": 1056,
	"./icons/icon-legend-wind.svg": 1057,
	"./icons/icon-live.svg": 1058,
	"./icons/icon-loader.svg": 1059,
	"./icons/icon-plus.svg": 1060,
	"./icons/icon-point--green.svg": 1061,
	"./icons/icon-point--red.svg": 1062,
	"./icons/icon-point.svg": 1063,
	"./icons/icon-print.svg": 1064,
	"./icons/icon-reef--green.svg": 1065,
	"./icons/icon-reef--red.svg": 1066,
	"./icons/icon-reef.svg": 1067,
	"./icons/icon-resort.svg": 1068,
	"./icons/icon-river--green.svg": 1069,
	"./icons/icon-river--red.svg": 1070,
	"./icons/icon-river.svg": 1071,
	"./icons/icon-sandbar--green.svg": 1072,
	"./icons/icon-sandbar--red.svg": 1073,
	"./icons/icon-sandbar.svg": 1074,
	"./icons/icon-search--bold.svg": 1075,
	"./icons/icon-search.svg": 1076,
	"./icons/icon-share.svg": 1077,
	"./icons/icon-thumbs-down-solid.svg": 1078,
	"./icons/icon-thumbs-up-solid.svg": 1079,
	"./icons/icon-tidal-range--blue.svg": 1080,
	"./icons/icon-tide-clock--color.svg": 1081,
	"./icons/icon-tide-needle.svg": 1082,
	"./icons/icon-tide-star.svg": 1083,
	"./icons/icon-user.svg": 1084,
	"./logos/apple-logo--black.svg": 96,
	"./logos/apple-logo--white.svg": 1085,
	"./logos/google-g-logo.svg": 97,
	"./logos/icon-facebook.svg": 1086,
	"./logos/icon-linkedin.svg": 1087,
	"./logos/icon-reddit.svg": 1088,
	"./logos/icon-telegram.svg": 1089,
	"./logos/icon-whatsapp.svg": 1090,
	"./logos/icon-x.svg": 1091,
	"./logos/outside-logo--black.svg": 1092,
	"./logos/outside-logo--white.svg": 1093,
	"./logos/surf-forecast__icon--white.svg": 1094,
	"./logos/surf-forecast__logo--black.svg": 1095,
	"./logos/surf-forecast__logo--clear.svg": 1096,
	"./logos/surf-forecast__logo--icon.svg": 1097,
	"./logos/surf-forecast__logo--white.svg": 1098,
	"./logos/surf-forecast__logo.svg": 1099
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1025;